import Symbol from './Symbol';
import SymbolMap from './SymbolMap';
import { DEFAULT_SYMBOL_MAP } from '@/pages/dsst/dsstConfig';

interface GuideScreenProps {
  onStart: () => void;
  setIndex: number;
}

const EXAMPLE_SYMBOL = 0; // 다이아몬드
const EXAMPLE_NUMBER = DEFAULT_SYMBOL_MAP[EXAMPLE_SYMBOL]; // 1

export default function GuideScreen({ onStart, setIndex }: GuideScreenProps) {
  return (
    <div className="relative h-full animate-fade-in-up">
      <div className="flex flex-col h-full px-6 pt-8 pb-6">
        {/* 제목 영역 */}
        <div className="text-center mb-5 shrink-0">
          <h1 className="text-2xl font-bold text-foreground-900 leading-tight">기호 맞추기</h1>
          <p className="text-sm font-medium text-primary-600 mt-1.5">#집중력</p>
        </div>

        {/* 안내 콘텐츠 카드 */}
        <div className="w-full flex-1 min-h-0 bg-white rounded-2xl border border-secondary-200 px-6 pt-6 pb-3 flex flex-col items-center">
          {/* 안내 문구 */}
          <p className="shrink-0 text-base font-semibold text-foreground-800 text-center leading-relaxed">
            제한 시간 동안 기호와 짝이 되는 숫자를
            <br />
            <strong className="font-bold">최대한 많이</strong> 맞춰보세요!
          </p>

          {/* 예시 영역 */}
          <div className="flex-1 min-h-0 flex flex-col items-center justify-center w-full">
            {/* 기호-숫자 대응표 예시 (정답 기호 강조) */}
            <div className="w-full bg-primary-50 rounded-xl px-3 py-2.5">
              <SymbolMap
                symbolMap={DEFAULT_SYMBOL_MAP}
                setIndex={setIndex}
                symbolSizeClass="w-7 h-7"
                highlightIndex={EXAMPLE_SYMBOL}
              />
            </div>

            {/* 특정 기호 제시 */}
            <div className="mt-12 text-center">
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-secondary-100 text-secondary-800">
                이 기호와 짝이 되는 숫자는?
              </span>
              <div className="mt-3 flex items-center justify-center text-primary-600">
                <Symbol symbolId={EXAMPLE_SYMBOL} setIndex={setIndex} className="w-16 h-16 animate-step-pulse" />
              </div>
            </div>

            {/* 숫자 선택 예시 (정답 숫자 강조) */}
            <div className="mt-12 grid grid-cols-6 gap-2 w-full">
              {[1, 2, 3, 4, 5, 6].map((n) => (
                <div key={n} className="flex flex-col items-center">
                  <div
                    className={`w-full aspect-square rounded-xl border-2 flex items-center justify-center text-lg font-bold ${
                      n === EXAMPLE_NUMBER
                        ? 'bg-primary-500 border-primary-500 text-white'
                        : 'bg-white border-secondary-300 text-foreground-800'
                    }`}
                  >
                    {n}
                  </div>
                  {n === EXAMPLE_NUMBER && (
                    <span className="mt-1 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-bold whitespace-nowrap bg-green-100 text-green-700">
                      정답!
                    </span>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* 하단 버튼 */}
        <div className="w-full mt-5 pb-2 shrink-0">
          <button
            onClick={onStart}
            className="w-full py-4 px-6 rounded-2xl bg-white text-primary-700 font-semibold text-lg whitespace-nowrap
              border-2 border-primary-200
              active:scale-[0.98] transition-transform duration-150
              hover:bg-primary-50"
          >
            연습 시작
          </button>
        </div>
      </div>
    </div>
  );
}